"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGrades = void 0;
const DefaultGradeKeys_1 = __importDefault(require("./DefaultGradeKeys"));
const Grade_1 = __importDefault(require("./Grade"));
const GradeColorKey_1 = __importDefault(require("./GradeColorKey"));
const PassStatus_1 = __importDefault(require("./PassStatus"));
exports.DefaultGrades = [
    new Grade_1.default(DefaultGradeKeys_1.default.UNDETERMINED, 'Undetermined', GradeColorKey_1.default.BLACK, PassStatus_1.default.UNDETERMINED),
    new Grade_1.default(DefaultGradeKeys_1.default.GREEN, 'Satisfactory', GradeColorKey_1.default.GREEN, PassStatus_1.default.PASS),
    new Grade_1.default(DefaultGradeKeys_1.default.AMBER, 'Needs Improvement', GradeColorKey_1.default.ORANGE, PassStatus_1.default.PASS),
    new Grade_1.default(DefaultGradeKeys_1.default.RED, 'Unsatisfactory', GradeColorKey_1.default.RED, PassStatus_1.default.FAIL),
];
exports.default = exports.DefaultGrades;
